import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { React, useContext } from "react";
import SaveIcon from "@mui/icons-material/Save";
import PublishIcon from "@mui/icons-material/Publish";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAllStates,
  saveProductGroupEdit,
  submitProductGroupEdit,
} from "./productGroupSetupSlice";
import dayjs from "dayjs";
import CollapseSection from "../../../components/ui/CollapseSection";


export default function Summary() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const pgState = useSelector((store) => store.productGroupSetup);
  const {
    eProductGroupName,
    selectedSKUs,
    fromDate,
    toDate,
    countryID,
    productGroupID,
    status,
    comments,
    productGroup,
    files,
  } = pgState;

  const dispatch = useDispatch();

  function getDateFromDayjsDate(date, exactTime) {
    console.log("PGEdit_getDateFromDayjsDate_InputDate", date);
    let outputDate = null;
    if (date && date instanceof dayjs) {
      const year = date.year();
      const month = date.month() + 1;
      const day = date.date();
      const time = new Date();

      if (exactTime) {
        const formattedTime = time.toLocaleTimeString("en-US", {
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        outputDate = `${year}-${month < 10 ? "0" + month : month}-${
          day < 10 ? "0" + day : day
        }T${formattedTime}`;
      } else {
        outputDate = `${year}-${month < 10 ? "0" + month : month}-${
          day < 10 ? "0" + day : day
        }T00:00:00`;
      }
    } else if (date && typeof date === "string") {
      outputDate = date;
    }
    console.log("PGEdit_getDateFromDayjsDate_OutputDate", outputDate);
    return outputDate;
  }

  function submitPG() {
    const data = JSON.parse(localStorage.getItem("data"));
    const email = data.email;
    const updatedBy = data.email;
    const date = dayjs();

    const submitData = new FormData();
    submitData.append("countryID", countryID);
    submitData.append("productGroupName", eProductGroupName);
    submitData.append("productGroupCode", productGroup.productGroupCode);
    submitData.append(
      "effectiveStartDate",
      getDateFromDayjsDate(fromDate, false)
    );
    submitData.append("effectiveEndDate", getDateFromDayjsDate(toDate, false));
    submitData.append("comments", comments);
    submitData.append("updatedBy", updatedBy);
    submitData.append("email", email);

    submitData.append("updatedDate", getDateFromDayjsDate(date, true));
    submitData.append("productGroupID", productGroup.productGroupID);
    submitData.append("sentToSAP", productGroup.sentToSAP);
    submitData.append("status", status);

    selectedSKUs.forEach((sku, index) => {
      submitData.append(
        "productGrouplist[" + index + "][productID]",
        sku.productID
      );
      submitData.append(
        "productGrouplist[" + index + "][productName]",
        sku.productName
      );
      submitData.append(
        "productGrouplist[" + index + "][effectiveStartDate]",
        getDateFromDayjsDate(sku.effectiveStartDate!=null?sku.effectiveStartDate:fromDate, false)
      );
      submitData.append(
        "productGrouplist[" + index + "][effectiveEndDate]",
        getDateFromDayjsDate(sku.effectiveEndDate!=null?sku.effectiveEndDate:toDate, false)
      );
    });

    files.forEach((file, index) => {
      if (file instanceof File === false) {
        submitData.append(`FilePaths[${index}]`, file.filePath);
      }
    });

    files.forEach((file, index) => {
      if (file instanceof File) {
        submitData.append("files", file);
      }
    });

    submitData?.forEach((value, key) => {
      console.log(key + " " + value);
    });

    dispatch(submitProductGroupEdit(submitData));
    dispatch(resetAllStates({ edit: true }));
  }

  function savePG() {
    const data = JSON.parse(localStorage.getItem("data"));
    const email = data.email;
    const updatedBy = data.email;
    const date = dayjs();

    const submitData = new FormData();
    submitData.append("countryID", countryID);
    submitData.append("productGroupName", eProductGroupName);
    submitData.append("productGroupCode", productGroup.productGroupCode);
    submitData.append(
      "effectiveStartDate",
      getDateFromDayjsDate(fromDate, false)
    );
    submitData.append("effectiveEndDate", getDateFromDayjsDate(toDate, false));
    submitData.append("comments", comments);
    submitData.append("updatedBy", updatedBy);
    submitData.append("email", email);

    submitData.append("updatedDate", getDateFromDayjsDate(date, true));
    submitData.append("productGroupID", productGroup.productGroupID);
    submitData.append("sentToSAP", productGroup.sentToSAP);
    submitData.append("status", status);

    selectedSKUs.forEach((sku, index) => {
      submitData.append(
        "productGrouplist[" + index + "][productID]",
        sku.productID
      );
      submitData.append(
        "productGrouplist[" + index + "][productName]",
        sku.productName
      );
      submitData.append(
        "productGrouplist[" + index + "][effectiveStartDate]",
        getDateFromDayjsDate(sku.effectiveStartDate!=null?sku.effectiveStartDate:fromDate, false)
      );
      submitData.append(
        "productGrouplist[" + index + "][effectiveEndDate]",
        getDateFromDayjsDate(sku.effectiveEndDate!=null?sku.effectiveEndDate:toDate, false)
      );
    });

    files.forEach((file, index) => {
      submitData.append("files", file);
    });

    submitData?.forEach((value, key) => {
      console.log(key + " " + value);
    });

    dispatch(saveProductGroupEdit(submitData));
    dispatch(resetAllStates({ edit: true }));
  }

  return (
    <Box sx={{ mt: 1 }}>
      {/* <Typography className="compHeading" sx={{fontWeight: "bold", color: "blue.main", width: "100%" }}>
		
					Summary
				</Typography> */}

      <CollapseSection title="Summary">
        <Typography sx={{ fontWeight: "bold" }}>Product Group Name:</Typography>
        <Typography>{eProductGroupName}</Typography>

        <Typography sx={{ fontWeight: "bold" }}>SKUs:</Typography>
        <Box
          sx={{
            width: 700,
            height: 200,
            border: 1,
            borderRadius: 1,
            overflow: "auto",
            borderColor: "#c6c6c6",
            marginBottom: "10px",
          }}
        >
          {selectedSKUs ? (
            <List>
              {selectedSKUs.map((item, index) => {
                return (
                  <ListItem key={index}>
                    <ListItemText>{item.productName}</ListItemText>
                  </ListItem>
                );
              })}
            </List>
          ) : (
            ""
          )}
        </Box>

        <Typography sx={{ fontWeight: "bold" }}>Validity Period:</Typography>
        <Typography>
          {" "}
          <strong>From:</strong>{" "}
          {new Date(fromDate).toLocaleDateString("en-UK", {
               year:'numeric',
               month:'2-digit',
               day:'2-digit'
            })}{" "}
          <strong>To:</strong>{" "}
          {new Date(toDate).toLocaleDateString("en-UK", {
               year:'numeric',
               month:'2-digit',
               day:'2-digit'
            })}
        </Typography>
      </CollapseSection>
      <Divider sx={{ mt: 4 }} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          mt: 2,
        }}
      >
        <Button
          startIcon={<SaveIcon />}
          disabled={!isRestrictedAccess}
          sx={{
            bgcolor: "blue.main",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            mr: 2,
            "&:hover": {
              bgcolor: "skyBlue.main",
              color: "black.main",
            },
          }}
          onClick={savePG}
        >
          Save
        </Button>

        <Button
          startIcon={<PublishIcon />}
          disabled={!isRestrictedAccess}
          sx={{
            bgcolor: "blue.main",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            "&:hover": {
              bgcolor: "skyBlue.main",
              color: "black.main",
            },
          }}
          onClick={submitPG}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}
